<template>
  <div class="container">
    <!-- <div class="bg">
      <img src="@/assets/images/bg.jpg" width="100%">
    </div> -->

    <div class="sign-in">
      <div class="descript">
        <div style="width: 60px; height: 100%;">
          <img src="@/assets/images/website-logo.jpg" style="width: 45px;height:45px;background-color: #fff;border-radius: 50%;padding:2px" />
        </div>
        <div class="logo">
          <div class="top">鑫诚砂石</div>
          <div class="bottom">XINCHENGSHASHI</div>

        </div>
      </div>
      <div style="
          width: 90%;
          height: 50px;
          margin: 25px auto;
          margin-bottom: 20px;
          display: flex;
          justify-content: center;
        ">

        <div style="margin-left: 10px">
          <h2 style="
              height: 50px;
              line-height: 50px;
              color: #666;
              font-weight: bold;
              font-size: 24px;
            ">
            进销存管理系统
          </h2>
        </div>
      </div>
      <a-spin :spinning="spinning">
        <form action="
        ">
          <a-form-model ref="ruleForm" :model="form" :rules="rules">
            <a-form-model-item :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol"
              prop="username">
              <a-input placeholder="请输入账号" size="large" v-model="form.username">
                <a-icon slot="prefix" type="user" />
              </a-input>
            </a-form-model-item>
            <!--  label='密码' -->
            <a-form-model-item :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol"
              prop="password">
              <a-input placeholder="请输入密码" size="large" type="password" v-model="form.password">
                <a-icon slot="prefix" type="lock" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item :labelCol="formItemLayout.labelCol" prop="captcha" style="display: flex;">
              <a-input placeholder="请输入右侧验证码" class="captch-img" size="large" v-model="form.captcha" style="width: 200px;">
                <!-- <div slot="addonAfter" style="background-color: pink;">
                
                </div>
                 -->
              </a-input>
              <valid-code @update="update" style="position: absolute;top:-12px;left: 210px;"></valid-code>
            </a-form-model-item>
            <a-form-model-item :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol"
              style="margin-bottom: 0" class="mima">
              <a-checkbox v-model="checked" @change="handleRememberMe">记住密码</a-checkbox>
              <span href class="fr" style="cursor: pointer" @click="forgetPwd">忘记密码</span>
            </a-form-model-item>
          </a-form-model>
        </form>

        <div>
          <a-button type="primary" @click="sign" style="width: 100%" size="large" :loading="loading">登录</a-button>
          <!-- <a-button
            style="width: 100%; margin: 10px 0 0 0"
            size="large"
            :loading="loading"
            @click="toRegister"
            >立即注册</a-button
          > -->
        </div>
      </a-spin>
    </div>
    <div class="copy">鄂ICP备2021017161号-1</div>
  </div>
</template>

<script>
import ValidCode from "@/components/ValidCode.vue";
import Utils from "@/utils/util.js";
let jwt = require("jsonwebtoken");
import { signUp } from "@/api/api.js";
export default {
  components: {
    ValidCode,
  },
  created() {
    let _this = this;
    document.onkeydown = function (e) {
      // 回车提交表单
      // 兼容FF和IE和Opera
      var theEvent = window.event || e;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        _this.sign();
      }
    };
  },
  data() {
    let validateCaptcha = (rule, value, callback) => {
      if (value.toUpperCase() !== this.captchaModel.toUpperCase()) {
        callback(new Error("验证码输入不正确"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      spinning: false,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 24 },
      },
      form: {
        username: "",
        password: "",
        captcha: "",
      },
      checked: false,
      captchaModel: "",

      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 12, message: "长度应该6至12位", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "密码只能是大小写英文字母或者数字",
            trigger: "blur",
          },
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { len: 4, message: "验证码仅能输入4位", trigger: "blur" },
          { validator: validateCaptcha, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    update(val) {
      this.captchaModel = val;
    },
    sign() {
      // this.$router.push('/')
      if (this.checked) {
        // 传入账号名，密码，和保存天数3个参数
        this.setCookie(this.form.username, this.form.password, 7);
      } else {
        // 如果没有选中自动登录，那就清除cookie
        this.setCookie("", "", -1); // 修改2值都为空，天数为负1天就好了
      }
      this.$refs.ruleForm.validate((valid) => {
        let timestamp = new Date().getTime() + "";
        let signParams = `SIGN_SECRETXCPERPSYSTEM20210904username${this.form.username}password${this.form.password}timestamp${timestamp}`;
        let sign = this.$sha256(signParams);
        let params = {
          username: this.form.username,
          password: this.form.password,
          timestamp: timestamp,
          sign: sign,
        };

        let encryptResult = Utils.encrypt(
          JSON.stringify(params),
          "egshfgjkiadsfgsd"
        );
        let req = {
          data: encryptResult,
        };
        // let rememberMe = this.checked + ""
        if (valid) {
          this.spinning = true;
          signUp(req).then((res) => {
            this.spinning = false;
            if (res.code == "0000") {
              if (this.checked) {
                localStorage.setItem("Token", res.data.Token);
              } else {
                sessionStorage.setItem("Token", res.data.Token);
              }
              let jwtToken = jwt.decode(
                sessionStorage.getItem("Token") || localStorage.getItem("Token")
              );
              localStorage.setItem("jwt", JSON.stringify(jwtToken));
              this.$router.push("/home");
              this.$message.success("登录成功");
              this.spinning = false;
            } else {
              this.$message.warn(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    forgetPwd() {
      alert("请联系公司人事部门重置密码!");
    },
    // 设置cookie
    setCookie(name, pwd, exdays) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        "username" + "=" + name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "password" + "=" + pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    // 读取cookie 将用户名和密码回显到input框中
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split(";"); // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); // 再次切割
          // 判断查找相对应的值
          console.log(arr2);
          if (arr2[0] === "username") {
            this.form.username = arr2[1]; // 保存到保存数据的地方
          } else if (arr2[0] === "password") {
            this.form.password = arr2[1];
          }
        }
      }
    },
    handleRememberMe() {
      if (this.checked) {
        // sessionStorage.removeItem("Token");
        this.getCookie();
      }
    },
    // toRegister() {
    //   this.$router.push('/register')
    // },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background: url("~@/assets/images/bg.jpg");
  background-size: cover;

  .descript {
    width: 200px;
    height: 60px;
    top: -80px;
    position: absolute;
    left: 48%;
    transform: translate(-50%);
    display: flex;
    .logo {
      .top {
        width: 150px;
        height: 35px;
        color: #000;
        font-family:粗体;
        font-size: 28px;
        font-weight: bold;
        line-height: 35px;
        letter-spacing: 5px;
        padding-left: 5px;
      }
      .bottom{
        width: 150px;
        height: 25px;
        font-size: 14px;
        line-height: 25px;
        letter-spacing: -1px;
        font-weight: bold;
        margin-left: -1px;
        color: #ccc;
      }
    }
  }

  .sign-in {
    width: 420px;
    height: 460px;
    background-color: #fff;
    box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 3px;

    /deep/ .ant-spin-container {
      width: 90%;
      margin: 20px auto;
    }

    .mima {
      /deep/ .ant-form-item-control-wrapper {
        display: flex;
        justify-content: space-between;
      }

      .fr {
        margin-left: 215px;
        color: #1890ff;
      }
    }

    /deep/ .ant-form-explain {
      text-align: left;
    }
  }

  .copy {
    font-size: 13px;
    color: #fff;
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>